module.exports = __webpack_public_path__ + "img/2.d19336fe.jpg";